var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import ListCell from '@doordash/component-list-cell';
import { InlineChildren, Text } from '@doordash/design-language';
import styled from 'styled-components';
import BillingHistoryStrings from './BillingHistoryStrings';
var BillType = styled(Text).attrs(function () { return ({
    styles: Text.Styles.Body2Emphasis,
    textAlign: Text.TextAlignments.Center,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 150px;\n"], ["\n  width: 150px;\n"])));
var BillingHistoryListHeader = function (_a) {
    var isEmActivated = _a.isEmActivated, shouldShowDpBillingDownload = _a.shouldShowDpBillingDownload;
    return (React.createElement(ListCell, { size: ListCell.Sizes.Small, title: BillingHistoryStrings.billingHistoryListHeaderMonth(), titleOverrides: { styles: Text.Styles.Body2Emphasis }, isSeparatorVisible: false, renderAfterContent: function () { return (React.createElement(InlineChildren, { size: InlineChildren.Sizes.Large },
            isEmActivated && (React.createElement(BillType, { children: BillingHistoryStrings.billingHistoryListHeaderEM() })),
            shouldShowDpBillingDownload && (React.createElement(BillType, { children: BillingHistoryStrings.billingHistoryListHeaderDP() })))); } }));
};
export default BillingHistoryListHeader;
var templateObject_1;
